import {
  SIDE_PANEL_CLEAN_UP,
  SET_SIDE_PANEL_CONTENT,
  SET_SIDE_PANEL_IS_OPEN,
  UPDATE_SIDE_PANEL_DATA,
  SET_SIDE_PANEL_WIDTH,
  SET_SIDE_PANEL_PRESERVE_MIN_WIDTH,
  SET_SIDE_PANEL_BACK_BUTTON,
  ACCEPT_PENDING_SIDE_PANEL_CONTENT,
  REJECT_PENDING_SIDE_PANEL_CONTENT,
  SET_SIDE_PANEL_TYPE,
  SET_SIDE_PANEL_CONTAINER_CLASSNAME,
  SET_SIDE_PANEL_DIRTY,
  UPDATE_SIDE_PANEL_PENDING_PROPERTIES,
  SET_GWT_NEXT_SIDE_PANEL_MESSAGE_CONTENT,
  CLEAR_GWT_NEXT_SIDE_PANEL_MESSAGE_CONTENT,
} from 'actions/sidePanel';
import shiftsReducer from './shifts';
import holidaysReducer from './holidays';

const defaultState = {
  content: null,
  history: {
    onBackNav: null,
    backButtonLabel: null,
  },
  isOpen: false,
  isDirty: false,
  panelWidth: 350,
  preserveMinWidth: false,
  pendingProps: null,
  type: null,
  containerClassName: null,
  GWTNextSidePanelMessageContent: null,
};

export default function sidePanel(state = defaultState, action) {
  switch (action.type) {
    case SET_SIDE_PANEL_CONTENT:
      if ((state.isOpen && state.isDirty) || state.pendingProps) {
        return {
          ...state,
          shift: shiftsReducer(state.shift, {
            type: UPDATE_SIDE_PANEL_PENDING_PROPERTIES,
          }),
          holiday: holidaysReducer(state.holiday, {
            type: UPDATE_SIDE_PANEL_PENDING_PROPERTIES,
          }),
          pendingProps: {
            ...state.pendingProps,
            content: action.payload,
            history: {
              ...defaultState.history,
            },
          },
        };
      }
      return {
        ...state,
        content: action.payload,
      };
    case SET_SIDE_PANEL_IS_OPEN:
      return {
        ...state,
        isOpen: action.payload,
      };
    case SIDE_PANEL_CLEAN_UP:
      return {
        ...state,
        ...defaultState,
        shift: shiftsReducer(state.shift, action),
        holiday: holidaysReducer(state.holiday, action),
      };
    case UPDATE_SIDE_PANEL_DATA:
      if (!state.content) return state;
      return {
        ...state,
        content: {
          ...state.content,
          id: action.payload.id,
          data: action.payload,
        },
      };
    case SET_SIDE_PANEL_WIDTH:
      if (state.pendingProps) {
        return {
          ...state,
          pendingProps: { ...state.pendingProps, panelWidth: action.payload },
        };
      }
      return {
        ...state,
        panelWidth: action.payload,
      };
    case SET_SIDE_PANEL_PRESERVE_MIN_WIDTH:
      return {
        ...state,
        preserveMinWidth: action.payload,
      };
    case SET_SIDE_PANEL_DIRTY:
      return {
        ...state,
        isDirty: action.payload,
      };
    case SET_SIDE_PANEL_BACK_BUTTON: {
      const { backButtonLabel = null, onBackNav = null } = action.payload;
      if (state.pendingProps) {
        return {
          ...state,
          pendingProps: {
            ...state.pendingProps,
            history: {
              onBackNav,
              backButtonLabel,
            },
          },
        };
      }
      return {
        ...state,
        history: {
          onBackNav,
          backButtonLabel,
        },
      };
    }
    case ACCEPT_PENDING_SIDE_PANEL_CONTENT:
      return {
        ...state,
        ...state.pendingProps,
        pendingProps: null,
        isDirty: false,
        shift: shiftsReducer(state.shift, action),
        holiday: holidaysReducer(state.holiday, action),
      };
    case REJECT_PENDING_SIDE_PANEL_CONTENT:
      return {
        ...state,
        pendingProps: null,
        isDirty: false,
        shift: shiftsReducer(state.shift, action),
        holiday: holidaysReducer(state.holiday, action),
      };
    case SET_SIDE_PANEL_TYPE:
      if ((state.isOpen && state.isDirty) || state.pendingProps) {
        return {
          ...state,
          shift: shiftsReducer(state.shift, {
            type: UPDATE_SIDE_PANEL_PENDING_PROPERTIES,
          }),
          holiday: holidaysReducer(state.holiday, {
            type: UPDATE_SIDE_PANEL_PENDING_PROPERTIES,
          }),
          pendingProps: {
            content: { ...state.content },
            ...state.pendingProps,
            type: action.payload,
          },
        };
      }
      return {
        ...state,
        type: action.payload,
      };
    case SET_SIDE_PANEL_CONTAINER_CLASSNAME:
      return {
        ...state,
        containerClassName: action.payload,
      };

    case SET_GWT_NEXT_SIDE_PANEL_MESSAGE_CONTENT:
      return {
        ...state,
        GWTNextSidePanelMessageContent: action.payload,
      };
    case CLEAR_GWT_NEXT_SIDE_PANEL_MESSAGE_CONTENT:
      return {
        ...state,
        GWTNextSidePanelMessageContent: null,
      };
    default:
      return {
        ...state,
        shift: shiftsReducer(state.shift, action),
        holiday: holidaysReducer(state.holiday, action),
      };
  }
}
